"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalLabels = exports.knowMoreLinks = void 0;
const labelBase = 'cta_new_club_migration.modal';
exports.knowMoreLinks = {
    PT_BR: 'https://solutions.hotmart.com/atualize-sua-area-de-membros',
    EN: 'https://solutions.hotmart.com/update-your-members-area',
    ES: 'https://solutions.hotmart.com/actualiza-tu-area-de-miembros'
};
exports.modalLabels = {
    ema: {
        title: `${labelBase}.old_ema.title`,
        description: `${labelBase}.old_ema.subtitle`,
        advantages: [
            `${labelBase}.advantages.integration_ema`,
            `${labelBase}.advantages.buyback`,
            `${labelBase}.advantages.tools`,
            `${labelBase}.advantages.netflix_ema`
        ]
    },
    newClub: {
        title: `${labelBase}.old_new.title`,
        description: `${labelBase}.old_new.subtitle`,
        advantages: [
            `${labelBase}.advantages.tools`,
            `${labelBase}.advantages.integration`,
            `${labelBase}.advantages.buyback`,
            `${labelBase}.advantages.ai`
        ]
    },
    oldClub: {
        title: `${labelBase}.old_old.title`,
        advantages: [
            `${labelBase}.advantages.tools`,
            `${labelBase}.advantages.netflix_experience`,
            `${labelBase}.advantages.buyback_2`,
            `${labelBase}.advantages.ai`
        ]
    }
};
